import { AxiosResponse } from "axios";

import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";
import {
  IKioskoConfigRes,
  IClaimsPageRes,
  IClaimsPageSponsor,
} from "./sponsors-service.interface";

interface IGetSponsorBySlugRes {
  data: IKioskoConfigRes;
}

export const getSponsorBySlug = async (
  slug: string,
): Promise<IKioskoConfigRes> => {
  const url = microserviceApiRoutes.v1.agents.sponsors.getBySlug(slug);
  const res = await microserviceApiAxios.get<
    Error,
    AxiosResponse<IGetSponsorBySlugRes>
  >(url);
  return res.data.data;
};

export const getClaimsPageSponsors = async (): Promise<
  IClaimsPageSponsor[]
> => {
  const url = microserviceApiRoutes.v1.agents.sponsors.claimsPage();
  const res = await microserviceApiAxios.get<
    Error,
    AxiosResponse<IClaimsPageRes>
  >(url);
  return res.data.data.items;
};
